import type { Config } from 'wagmi'
import { getPublicClient } from '@wagmi/core'
import type { PublicClient } from 'viem'
import { createViemClient } from 'uniswap/src/features/providers/createViemClient'
import { UniverseChainId } from 'uniswap/src/features/chains/types'

let _wagmiConfig: Config | undefined

export function setUniswapWagmiConfig(config: Config) {
  _wagmiConfig = config
}

export function getUniswapWagmiPublicClient(chainId: number): PublicClient | undefined {
  if (_wagmiConfig) {
    try {
      return getPublicClient(_wagmiConfig, { chainId })
    } catch {}
  }
  // Fallback to our internal RPC client if wagmi config is not registered
  return createViemClient(chainId as UniverseChainId)
}


